"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.SwaggerException = exports.UserStatsViewModel = exports.ClaimedPaw = exports.PartnerClaimsViewModel = exports.UpdatePawPicSetModel = exports.PawPicSetConfigViewModel = exports.PicPointRelationModel = exports.PawPicSetConfigCreateModel = exports.CreatePawPicSetModel = exports.PawListViewModel = exports.PawPicSetStatus = exports.Feet = exports.PawPicSetViewModel = exports.Status = exports.PawDetailViewModel = exports.OfferToPawPartnerModel = exports.UpdatePawModel = exports.Gender = exports.CreatePawModel = exports.Role = exports.AccountResponse = exports.PartnerListView = exports.UpdateAccountModel = exports.CompanyModel = exports.AddressModel = exports.RegisterRequest = exports.GetTokenQuery = exports.LoginResponse = exports.StatsClient = exports.PawsClient = exports.AccountsClient = exports.addToken = void 0;
var AccountsClient = /** @class */ (function () {
    function AccountsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    AccountsClient.prototype.login = function (query) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/login";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(query);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processLogin(_response);
        });
    };
    AccountsClient.prototype.processLogin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.register = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processRegister(_response);
        });
    };
    AccountsClient.prototype.processRegister = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_1 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_1, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.update = function (id, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdate(_response);
        });
    };
    AccountsClient.prototype.processUpdate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_2 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_2, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.getById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetById(_response);
        });
    };
    AccountsClient.prototype.processGetById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AccountResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype["delete"] = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    AccountsClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_3 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_3, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.confirmEmail = function (email, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{email}/confirm/{token}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processConfirmEmail(_response);
        });
    };
    AccountsClient.prototype.processConfirmEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_4 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_4, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.resendConfirmEmail = function (email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{email}/resend";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processResendConfirmEmail(_response);
        });
    };
    AccountsClient.prototype.processResendConfirmEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_5 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_5, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.forgotPassword = function (email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{email}/password/forgot";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processForgotPassword(_response);
        });
    };
    AccountsClient.prototype.processForgotPassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_6 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_6, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.resetPassword = function (email, password, confirmPassword, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{email}/password/reset?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (confirmPassword !== undefined && confirmPassword !== null)
            url_ += "confirmPassword=" + encodeURIComponent("" + confirmPassword) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processResetPassword(_response);
        });
    };
    AccountsClient.prototype.processResetPassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_7 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_7, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.activate = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{id}/activation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processActivate(_response);
        });
    };
    AccountsClient.prototype.processActivate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_8 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_8, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.deactivate = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts/{id}/deactivation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeactivate(_response);
        });
    };
    AccountsClient.prototype.processDeactivate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_9 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_9, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AccountsClient.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Accounts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    AccountsClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(PartnerListView.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return AccountsClient;
}());
exports.AccountsClient = AccountsClient;
var PawsClient = /** @class */ (function () {
    function PawsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    PawsClient.prototype.create = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreate(_response);
        });
    };
    PawsClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.getPaws = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetPaws(_response);
        });
    };
    PawsClient.prototype.processGetPaws = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(PawListViewModel.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.update = function (pawId, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdate(_response);
        });
    };
    PawsClient.prototype.processUpdate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_10 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_10, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype["delete"] = function (pawId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    PawsClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_11 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_11, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.getPawById = function (pawId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetPawById(_response);
        });
    };
    PawsClient.prototype.processGetPawById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PawDetailViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.offerToPawPartner = function (pawId, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/offer";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processOfferToPawPartner(_response);
        });
    };
    PawsClient.prototype.processOfferToPawPartner = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_12 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_12, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.claimPaw = function (pawId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/claim";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processClaimPaw(_response);
        });
    };
    PawsClient.prototype.processClaimPaw = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_13 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_13, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.reworkPaw = function (pawId, reason) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/rework?";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processReworkPaw(_response);
        });
    };
    PawsClient.prototype.processReworkPaw = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_14 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_14, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.donePaw = function (pawId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/done";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDonePaw(_response);
        });
    };
    PawsClient.prototype.processDonePaw = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_15 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_15, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.rejectPaw = function (pawId, reason) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/reject?";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processRejectPaw(_response);
        });
    };
    PawsClient.prototype.processRejectPaw = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_16 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_16, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.createPawPicSet = function (pawId, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreatePawPicSet(_response);
        });
    };
    PawsClient.prototype.processCreatePawPicSet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.createPawPicSetConfig = function (pawId, ppsid, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets/{ppsid}/config";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (ppsid === undefined || ppsid === null)
            throw new Error("The parameter 'ppsid' must be defined.");
        url_ = url_.replace("{ppsid}", encodeURIComponent("" + ppsid));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreatePawPicSetConfig(_response);
        });
    };
    PawsClient.prototype.processCreatePawPicSetConfig = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_17 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_17, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.getPawPicSetConfig = function (pawId, ppsid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets/{ppsid}/config";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (ppsid === undefined || ppsid === null)
            throw new Error("The parameter 'ppsid' must be defined.");
        url_ = url_.replace("{ppsid}", encodeURIComponent("" + ppsid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetPawPicSetConfig(_response);
        });
    };
    PawsClient.prototype.processGetPawPicSetConfig = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PawPicSetConfigViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.downloadPdf = function (pawId, ppsid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets/{ppsid}/pdf";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (ppsid === undefined || ppsid === null)
            throw new Error("The parameter 'ppsid' must be defined.");
        url_ = url_.replace("{ppsid}", encodeURIComponent("" + ppsid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDownloadPdf(_response);
        });
    };
    PawsClient.prototype.processDownloadPdf = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.deletePawPicSet = function (pawId, ppsId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets/{ppsId}";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (ppsId === undefined || ppsId === null)
            throw new Error("The parameter 'ppsId' must be defined.");
        url_ = url_.replace("{ppsId}", encodeURIComponent("" + ppsId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeletePawPicSet(_response);
        });
    };
    PawsClient.prototype.processDeletePawPicSet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_18 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_18, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.updatePawPicSet = function (pawId, ppsId, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/{pawId}/pawpicsets/{ppsId}";
        if (pawId === undefined || pawId === null)
            throw new Error("The parameter 'pawId' must be defined.");
        url_ = url_.replace("{pawId}", encodeURIComponent("" + pawId));
        if (ppsId === undefined || ppsId === null)
            throw new Error("The parameter 'ppsId' must be defined.");
        url_ = url_.replace("{ppsId}", encodeURIComponent("" + ppsId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdatePawPicSet(_response);
        });
    };
    PawsClient.prototype.processUpdatePawPicSet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_19 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_19, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    PawsClient.prototype.getClaims = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Paws/claims";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetClaims(_response);
        });
    };
    PawsClient.prototype.processGetClaims = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(PartnerClaimsViewModel.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PawsClient;
}());
exports.PawsClient = PawsClient;
var StatsClient = /** @class */ (function () {
    function StatsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    StatsClient.prototype.getUserStats = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stats/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        options_ = addToken(options_);
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetUserStats(_response);
        });
    };
    StatsClient.prototype.processGetUserStats = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserStatsViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return StatsClient;
}());
exports.StatsClient = StatsClient;
var LoginResponse = /** @class */ (function () {
    function LoginResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoginResponse.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.token = _data["token"];
        }
    };
    LoginResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginResponse();
        result.init(data);
        return result;
    };
    LoginResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    };
    return LoginResponse;
}());
exports.LoginResponse = LoginResponse;
var GetTokenQuery = /** @class */ (function () {
    function GetTokenQuery(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTokenQuery.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    };
    GetTokenQuery.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTokenQuery();
        result.init(data);
        return result;
    };
    GetTokenQuery.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    };
    return GetTokenQuery;
}());
exports.GetTokenQuery = GetTokenQuery;
var RegisterRequest = /** @class */ (function () {
    function RegisterRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterRequest.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isCompany = _data["isCompany"];
            this.termsAccepted = _data["termsAccepted"];
            this.newsletterAccepted = _data["newsletterAccepted"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined;
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : undefined;
        }
    };
    RegisterRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterRequest();
        result.init(data);
        return result;
    };
    RegisterRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isCompany"] = this.isCompany;
        data["termsAccepted"] = this.termsAccepted;
        data["newsletterAccepted"] = this.newsletterAccepted;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    };
    return RegisterRequest;
}());
exports.RegisterRequest = RegisterRequest;
var AddressModel = /** @class */ (function () {
    function AddressModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddressModel.prototype.init = function (_data) {
        if (_data) {
            this.street = _data["street"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    };
    AddressModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddressModel();
        result.init(data);
        return result;
    };
    AddressModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    };
    return AddressModel;
}());
exports.AddressModel = AddressModel;
var CompanyModel = /** @class */ (function () {
    function CompanyModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyModel.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.ik = _data["ik"];
            this.craftsmenRegister = _data["craftsmenRegister"];
            this.pq_since = _data["pq_since"] ? new Date(_data["pq_since"].toString()) : undefined;
            this.pq_until = _data["pq_until"] ? new Date(_data["pq_until"].toString()) : undefined;
            this.serviceAreas = _data["serviceAreas"];
            this.companyId = _data["companyId"];
        }
    };
    CompanyModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyModel();
        result.init(data);
        return result;
    };
    CompanyModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["ik"] = this.ik;
        data["craftsmenRegister"] = this.craftsmenRegister;
        data["pq_since"] = this.pq_since ? this.pq_since.toISOString() : undefined;
        data["pq_until"] = this.pq_until ? this.pq_until.toISOString() : undefined;
        data["serviceAreas"] = this.serviceAreas;
        data["companyId"] = this.companyId;
        return data;
    };
    return CompanyModel;
}());
exports.CompanyModel = CompanyModel;
var UpdateAccountModel = /** @class */ (function () {
    function UpdateAccountModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateAccountModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.newsletterAccepted = _data["newsletterAccepted"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined;
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : undefined;
        }
    };
    UpdateAccountModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateAccountModel();
        result.init(data);
        return result;
    };
    UpdateAccountModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["newsletterAccepted"] = this.newsletterAccepted;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    };
    return UpdateAccountModel;
}());
exports.UpdateAccountModel = UpdateAccountModel;
var PartnerListView = /** @class */ (function () {
    function PartnerListView(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartnerListView.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.isActivated = _data["isActivated"];
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.postCode = _data["postCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.ik = _data["ik"];
        }
    };
    PartnerListView.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PartnerListView();
        result.init(data);
        return result;
    };
    PartnerListView.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActivated"] = this.isActivated;
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["postCode"] = this.postCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["ik"] = this.ik;
        return data;
    };
    return PartnerListView;
}());
exports.PartnerListView = PartnerListView;
var AccountResponse = /** @class */ (function () {
    function AccountResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountResponse.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined;
            this.isActivated = _data["isActivated"];
            this.newsletterAccepted = _data["newsletterAccepted"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined;
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : undefined;
        }
    };
    AccountResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountResponse();
        result.init(data);
        return result;
    };
    AccountResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined;
        data["isActivated"] = this.isActivated;
        data["newsletterAccepted"] = this.newsletterAccepted;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    };
    return AccountResponse;
}());
exports.AccountResponse = AccountResponse;
var Role;
(function (Role) {
    Role[Role["Admin"] = 0] = "Admin";
    Role[Role["Partner"] = 1] = "Partner";
    Role[Role["User"] = 2] = "User";
})(Role = exports.Role || (exports.Role = {}));
var CreatePawModel = /** @class */ (function () {
    function CreatePawModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePawModel.prototype.init = function (_data) {
        if (_data) {
            this.forename = _data["forename"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : undefined;
            this.alternativeDeliveryAddress = _data["alternativeDeliveryAddress"] ? AddressModel.fromJS(_data["alternativeDeliveryAddress"]) : undefined;
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.shoeSize = _data["shoeSize"];
            this.comment = _data["comment"];
        }
    };
    CreatePawModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePawModel();
        result.init(data);
        return result;
    };
    CreatePawModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["forename"] = this.forename;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["alternativeDeliveryAddress"] = this.alternativeDeliveryAddress ? this.alternativeDeliveryAddress.toJSON() : undefined;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["shoeSize"] = this.shoeSize;
        data["comment"] = this.comment;
        return data;
    };
    return CreatePawModel;
}());
exports.CreatePawModel = CreatePawModel;
var Gender;
(function (Gender) {
    Gender[Gender["None"] = 0] = "None";
    Gender[Gender["Female"] = 1] = "Female";
    Gender[Gender["Male"] = 2] = "Male";
})(Gender = exports.Gender || (exports.Gender = {}));
var UpdatePawModel = /** @class */ (function () {
    function UpdatePawModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdatePawModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.forename = _data["forename"];
            this.name = _data["name"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : undefined;
            this.gender = _data["gender"];
            this.alternativeDeliveryAddress = _data["alternativeDeliveryAddress"] ? AddressModel.fromJS(_data["alternativeDeliveryAddress"]) : undefined;
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.shoeSize = _data["shoeSize"];
            this.comment = _data["comment"];
        }
    };
    UpdatePawModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdatePawModel();
        result.init(data);
        return result;
    };
    UpdatePawModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forename"] = this.forename;
        data["name"] = this.name;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["gender"] = this.gender;
        data["alternativeDeliveryAddress"] = this.alternativeDeliveryAddress ? this.alternativeDeliveryAddress.toJSON() : undefined;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["shoeSize"] = this.shoeSize;
        data["comment"] = this.comment;
        return data;
    };
    return UpdatePawModel;
}());
exports.UpdatePawModel = UpdatePawModel;
var OfferToPawPartnerModel = /** @class */ (function () {
    function OfferToPawPartnerModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OfferToPawPartnerModel.prototype.init = function (_data) {
        if (_data) {
            this.pawId = _data["pawId"];
            this.companyName = _data["companyName"];
        }
    };
    OfferToPawPartnerModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OfferToPawPartnerModel();
        result.init(data);
        return result;
    };
    OfferToPawPartnerModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawId"] = this.pawId;
        data["companyName"] = this.companyName;
        return data;
    };
    return OfferToPawPartnerModel;
}());
exports.OfferToPawPartnerModel = OfferToPawPartnerModel;
var PawDetailViewModel = /** @class */ (function () {
    function PawDetailViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PawDetailViewModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.forename = _data["forename"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.shoeSize = _data["shoeSize"];
            this.comment = _data["comment"];
            this.deliveryAddress = _data["deliveryAddress"] ? AddressModel.fromJS(_data["deliveryAddress"]) : undefined;
            this.pawPartner = _data["pawPartner"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            if (Array.isArray(_data["pawPicSets"])) {
                this.pawPicSets = [];
                for (var _i = 0, _a = _data["pawPicSets"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pawPicSets.push(PawPicSetViewModel.fromJS(item));
                }
            }
        }
    };
    PawDetailViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PawDetailViewModel();
        result.init(data);
        return result;
    };
    PawDetailViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["name"] = this.name;
        data["forename"] = this.forename;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["shoeSize"] = this.shoeSize;
        data["comment"] = this.comment;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : undefined;
        data["pawPartner"] = this.pawPartner;
        data["reason"] = this.reason;
        data["status"] = this.status;
        if (Array.isArray(this.pawPicSets)) {
            data["pawPicSets"] = [];
            for (var _i = 0, _a = this.pawPicSets; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pawPicSets"].push(item.toJSON());
            }
        }
        return data;
    };
    return PawDetailViewModel;
}());
exports.PawDetailViewModel = PawDetailViewModel;
var Status;
(function (Status) {
    Status[Status["Free"] = 0] = "Free";
    Status[Status["Offered"] = 1] = "Offered";
    Status[Status["Rejected"] = 2] = "Rejected";
    Status[Status["Claimed"] = 3] = "Claimed";
    Status[Status["Rework"] = 4] = "Rework";
    Status[Status["Done"] = 5] = "Done";
    Status[Status["PicturesCreated"] = 6] = "PicturesCreated";
})(Status = exports.Status || (exports.Status = {}));
var PawPicSetViewModel = /** @class */ (function () {
    function PawPicSetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PawPicSetViewModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.feetType = _data["feetType"];
            this.status = _data["status"];
            this.feet = _data["feet"];
            this.imprint = _data["imprint"];
        }
    };
    PawPicSetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PawPicSetViewModel();
        result.init(data);
        return result;
    };
    PawPicSetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["feetType"] = this.feetType;
        data["status"] = this.status;
        data["feet"] = this.feet;
        data["imprint"] = this.imprint;
        return data;
    };
    return PawPicSetViewModel;
}());
exports.PawPicSetViewModel = PawPicSetViewModel;
var Feet;
(function (Feet) {
    Feet[Feet["Left"] = 1] = "Left";
    Feet[Feet["Right"] = 2] = "Right";
})(Feet = exports.Feet || (exports.Feet = {}));
var PawPicSetStatus;
(function (PawPicSetStatus) {
    PawPicSetStatus[PawPicSetStatus["New"] = 0] = "New";
    PawPicSetStatus[PawPicSetStatus["Ready"] = 1] = "Ready";
    PawPicSetStatus[PawPicSetStatus["Done"] = 2] = "Done";
    PawPicSetStatus[PawPicSetStatus["Error"] = 9] = "Error";
})(PawPicSetStatus = exports.PawPicSetStatus || (exports.PawPicSetStatus = {}));
var PawListViewModel = /** @class */ (function () {
    function PawListViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PawListViewModel.prototype.init = function (_data) {
        if (_data) {
            this.pawId = _data["pawId"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    };
    PawListViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PawListViewModel();
        result.init(data);
        return result;
    };
    PawListViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawId"] = this.pawId;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    };
    return PawListViewModel;
}());
exports.PawListViewModel = PawListViewModel;
var CreatePawPicSetModel = /** @class */ (function () {
    function CreatePawPicSetModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePawPicSetModel.prototype.init = function (_data) {
        if (_data) {
            this.pawId = _data["pawId"];
            this.feetType = _data["feetType"];
            this.feet = _data["feet"];
            this.imprint = _data["imprint"];
        }
    };
    CreatePawPicSetModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePawPicSetModel();
        result.init(data);
        return result;
    };
    CreatePawPicSetModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawId"] = this.pawId;
        data["feetType"] = this.feetType;
        data["feet"] = this.feet;
        data["imprint"] = this.imprint;
        return data;
    };
    return CreatePawPicSetModel;
}());
exports.CreatePawPicSetModel = CreatePawPicSetModel;
var PawPicSetConfigCreateModel = /** @class */ (function () {
    function PawPicSetConfigCreateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PawPicSetConfigCreateModel.prototype.init = function (_data) {
        if (_data) {
            this.pawId = _data["pawId"];
            this.pawPicSetId = _data["pawPicSetId"];
            this.feetPoints = _data["feetPoints"] ? PicPointRelationModel.fromJS(_data["feetPoints"]) : undefined;
            this.imprintPoints = _data["imprintPoints"] ? PicPointRelationModel.fromJS(_data["imprintPoints"]) : undefined;
            this.algorithm = _data["algorithm"];
            this.threshold = _data["threshold"];
            this.cutSelected = _data["cutSelected"];
            this.contrastSelected = _data["contrastSelected"];
            this.thresholdSelected = _data["thresholdSelected"];
            this.feetRotation = _data["feetRotation"];
            this.imprintRotation = _data["imprintRotation"];
        }
    };
    PawPicSetConfigCreateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PawPicSetConfigCreateModel();
        result.init(data);
        return result;
    };
    PawPicSetConfigCreateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawId"] = this.pawId;
        data["pawPicSetId"] = this.pawPicSetId;
        data["feetPoints"] = this.feetPoints ? this.feetPoints.toJSON() : undefined;
        data["imprintPoints"] = this.imprintPoints ? this.imprintPoints.toJSON() : undefined;
        data["algorithm"] = this.algorithm;
        data["threshold"] = this.threshold;
        data["cutSelected"] = this.cutSelected;
        data["contrastSelected"] = this.contrastSelected;
        data["thresholdSelected"] = this.thresholdSelected;
        data["feetRotation"] = this.feetRotation;
        data["imprintRotation"] = this.imprintRotation;
        return data;
    };
    return PawPicSetConfigCreateModel;
}());
exports.PawPicSetConfigCreateModel = PawPicSetConfigCreateModel;
var PicPointRelationModel = /** @class */ (function () {
    function PicPointRelationModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PicPointRelationModel.prototype.init = function (_data) {
        if (_data) {
            this.x1 = _data["x1"];
            this.y1 = _data["y1"];
            this.x2 = _data["x2"];
            this.y2 = _data["y2"];
            this.x3 = _data["x3"];
            this.y3 = _data["y3"];
            this.x4 = _data["x4"];
            this.y4 = _data["y4"];
        }
    };
    PicPointRelationModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PicPointRelationModel();
        result.init(data);
        return result;
    };
    PicPointRelationModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["x1"] = this.x1;
        data["y1"] = this.y1;
        data["x2"] = this.x2;
        data["y2"] = this.y2;
        data["x3"] = this.x3;
        data["y3"] = this.y3;
        data["x4"] = this.x4;
        data["y4"] = this.y4;
        return data;
    };
    return PicPointRelationModel;
}());
exports.PicPointRelationModel = PicPointRelationModel;
var PawPicSetConfigViewModel = /** @class */ (function () {
    function PawPicSetConfigViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PawPicSetConfigViewModel.prototype.init = function (_data) {
        if (_data) {
            this.pawPicSetId = _data["pawPicSetId"];
            this.feetPoints = _data["feetPoints"] ? PicPointRelationModel.fromJS(_data["feetPoints"]) : undefined;
            this.imprintPoints = _data["imprintPoints"] ? PicPointRelationModel.fromJS(_data["imprintPoints"]) : undefined;
            this.algorithm = _data["algorithm"];
            this.threshold = _data["threshold"];
            this.cutSelected = _data["cutSelected"];
            this.contrastSelected = _data["contrastSelected"];
            this.thresholdSelected = _data["thresholdSelected"];
            this.feetRotation = _data["feetRotation"];
            this.imprintRotation = _data["imprintRotation"];
        }
    };
    PawPicSetConfigViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PawPicSetConfigViewModel();
        result.init(data);
        return result;
    };
    PawPicSetConfigViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawPicSetId"] = this.pawPicSetId;
        data["feetPoints"] = this.feetPoints ? this.feetPoints.toJSON() : undefined;
        data["imprintPoints"] = this.imprintPoints ? this.imprintPoints.toJSON() : undefined;
        data["algorithm"] = this.algorithm;
        data["threshold"] = this.threshold;
        data["cutSelected"] = this.cutSelected;
        data["contrastSelected"] = this.contrastSelected;
        data["thresholdSelected"] = this.thresholdSelected;
        data["feetRotation"] = this.feetRotation;
        data["imprintRotation"] = this.imprintRotation;
        return data;
    };
    return PawPicSetConfigViewModel;
}());
exports.PawPicSetConfigViewModel = PawPicSetConfigViewModel;
var UpdatePawPicSetModel = /** @class */ (function () {
    function UpdatePawPicSetModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdatePawPicSetModel.prototype.init = function (_data) {
        if (_data) {
            this.pawId = _data["pawId"];
            this.pawPicSetId = _data["pawPicSetId"];
            this.feetType = _data["feetType"];
            this.feet = _data["feet"];
            this.imprint = _data["imprint"];
        }
    };
    UpdatePawPicSetModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdatePawPicSetModel();
        result.init(data);
        return result;
    };
    UpdatePawPicSetModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pawId"] = this.pawId;
        data["pawPicSetId"] = this.pawPicSetId;
        data["feetType"] = this.feetType;
        data["feet"] = this.feet;
        data["imprint"] = this.imprint;
        return data;
    };
    return UpdatePawPicSetModel;
}());
exports.UpdatePawPicSetModel = UpdatePawPicSetModel;
var PartnerClaimsViewModel = /** @class */ (function () {
    function PartnerClaimsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartnerClaimsViewModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["claimedPaws"])) {
                this.claimedPaws = [];
                for (var _i = 0, _a = _data["claimedPaws"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.claimedPaws.push(ClaimedPaw.fromJS(item));
                }
            }
        }
    };
    PartnerClaimsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PartnerClaimsViewModel();
        result.init(data);
        return result;
    };
    PartnerClaimsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.claimedPaws)) {
            data["claimedPaws"] = [];
            for (var _i = 0, _a = this.claimedPaws; _i < _a.length; _i++) {
                var item = _a[_i];
                data["claimedPaws"].push(item.toJSON());
            }
        }
        return data;
    };
    return PartnerClaimsViewModel;
}());
exports.PartnerClaimsViewModel = PartnerClaimsViewModel;
var ClaimedPaw = /** @class */ (function () {
    function ClaimedPaw(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimedPaw.prototype.init = function (_data) {
        if (_data) {
            this.description = _data["description"];
            this.claimedDate = _data["claimedDate"] ? new Date(_data["claimedDate"].toString()) : undefined;
        }
    };
    ClaimedPaw.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimedPaw();
        result.init(data);
        return result;
    };
    ClaimedPaw.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["claimedDate"] = this.claimedDate ? this.claimedDate.toISOString() : undefined;
        return data;
    };
    return ClaimedPaw;
}());
exports.ClaimedPaw = ClaimedPaw;
var UserStatsViewModel = /** @class */ (function () {
    function UserStatsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserStatsViewModel.prototype.init = function (_data) {
        if (_data) {
            this.partner = _data["partner"];
            this.customers = _data["customers"];
        }
    };
    UserStatsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserStatsViewModel();
        result.init(data);
        return result;
    };
    UserStatsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner;
        data["customers"] = this.customers;
        return data;
    };
    return UserStatsViewModel;
}());
exports.UserStatsViewModel = UserStatsViewModel;
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
exports.SwaggerException = SwaggerException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}


// manually added
function addToken(options){
    let token = localStorage.getItem("token")
    if(!token)
        token = sessionStorage.getItem("token")
    if(!token){
        return options; // no token set --> nothing to do!
    } else {
        if(!options.headers){
            options.headers = {};
        }
        options.headers.Authorization = "Bearer " + token;
        return options
    }
}

exports.addToken = addToken
